"use client";
import Link from "next/link";
import React from "react";
import toast, { Toaster } from "react-hot-toast";

interface Props {
  country: string;
  count: number;
  href: string;
}

export default function TotalNumbersCard({ country, count, href }: Props) {
  return (
    <>
      <Toaster position="top-right" reverseOrder={false} />

      <div className="bg-white flex items-center space-y-6 flex-col w-full h-auto p-6 border border-sb_green rounded-xl">
        <p className="text-center text-xl font-bold font-spaceGrotesk text-zinc-700">
          {country}
        </p>

        <div className=" text-center w-full">
          <p className="font-spaceGrotesk text-6xl font-bold">{count}</p>
          <p className="text-zinc-600 text-sm font-semibold">
            Numbers Available
          </p>
        </div>

        <div>
          <Link href={href}>
            <div
              className={`px-6 transition-all duration-300 hover:px-8 py-3 bg-sb_green hover:bg-sb_green/90 text-white font-semibold rounded-lg`}
            >
              See Free Numbers
            </div>
          </Link>
        </div>
      </div>
    </>
  );
}
